export default defineNuxtRouteMiddleware(async (to) => {
  // Pokud přijde potvrzovací kód v query na libovolnou URL (např. "/?code=..."),
  // přesměrujeme ho na dedikovanou callback stránku pro zpracování potvrzení.
  if (to.query && typeof to.query.code !== 'undefined' && to.path !== '/auth/callback') {
    return navigateTo({ path: '/auth/callback', query: { code: String(to.query.code) } })
  }

  // No page matches this URL. Let Nuxt answer with its 404: sending an
  // anonymous visitor to "/" made every mistyped or deleted URL a 302 to the
  // homepage, which search engines treat as a soft 404.
  if (to.matched.length === 0) {
    return
  }

  // Povolit také cesty, které jsou explicitně označené jako veřejné přes meta
  const metaAuth = (to.meta as { auth?: boolean })?.auth
  const isPublicRoute = metaAuth === false || isPublicPath(to.path)

  // The session lookup happens AFTER the public-route check so it stays off the
  // render path of the pages crawlers hit most. /login and /registration still
  // need it for the logged-in -> /cv redirect below.
  const needsSession = !isPublicRoute || to.path === '/login' || to.path === '/registration'
  if (!needsSession) {
    return
  }

  const supabase = useSupabaseClient()
  const { data: { session } } = await supabase.auth.getSession()

  // Pokud uživatel není přihlášen a není na veřejné stránce, přesměrujeme ho na login
  if (!session && !isPublicRoute) {
    return navigateTo('/')
  }

  // Pokud je uživatel přihlášen a je na login/register stránce, přesměrujeme ho na hlavní stránku
  // A purchase link (/login?checkout=pack-monthly, from the pack's e-mails)
  // goes on to that checkout: the editor opens it.
  if (session && ['/login', '/register'].includes(to.path)) {
    const checkout = typeof to.query.checkout === 'string' ? to.query.checkout : null
    return navigateTo(checkout ? { path: '/cv', query: { checkout } } : '/cv')
  }
})
